import { $post, $download } from '@/api/request'
// 公司信息 查询
export function queryCompany(data) {
  return $post({
    url: '/companyInfo/query',
    data
  })
}
// 新增 公司
export function addCompany(data) {
  return $post({
    url: '/companyInfo/add',
    data
  })
}
// 编辑 公司
export function updateCompany(data) {
  return $post({
    url: '/companyInfo/update',
    data
  })
}
// 删除 公司
export function deleteCompany(data) {
  return $post({
    url: '/companyInfo/delete',
    data
  })
}
// 新增 公司账户
export function addCompanyBank(data) {
  return $post({
    url: '/companyBankRelation/add',
    data
  })
}
// 查询 公司账户
export function queryCompanyBank(data) {
  return $post({
    url: '/companyBankRelation/query',
    data
  })
}
// 查询 公司账号单条信息
export function queryIdCompanyBank(data) {
  return $post({
    url: '/companyBankRelation/queryById',
    data
  })
}
// 更新 公司账号信息
export function updateCompanyBank(data) {
  return $post({
    url: '/companyBankRelation/update',
    data
  })
}
// 删除 公司账户
export function deleteCompanyBank(data) {
  return $post({
    url: '/companyBankRelation/delete',
    data
  })
}
// 新增 楼宇
export function addBuilding(data) {
  return $post({
    url: '/buildingInfo/add',
    data
  })
}
// 上传产证图片
export function uploadPic(data) {
  return $post({
    url: '/minio/imageUpload',
    data
  })
}
// 查询 楼宇信息
export function queryBuilding(data) {
  return $post({
    url: '/buildingInfo/query',
    data
  })
}
// 删除楼宇
export function deleteBuilding(data) {
  return $post({
    url: '/buildingInfo/delete',
    data
  })
}
// 编辑楼宇
export function updateBuilding(data) {
  return $post({
    url: '/buildingInfo/update',
    data
  })
}
// 查询 单条楼宇信息
export function queryIdBuild(data) {
  return $post({
    url: '/buildingInfo/queryById',
    data
  })
}
// 删除图片
export function deletefile(data) {
  return $post({
    url: '/minio/fileDelete',
    data
  })
}
// 新增用户
export function addUserInfo(data) {
  return $post({
    url: '/userInfo/add',
    data
  })
}
// 查询可关联人才用户
export function listCanRelTel(data) {
  return $post({
    url: '/userInfo/listCanRelTel',
    data
  })
}
// 查询用户
export function queryUserInfo(data) {
  return $post({
    url: '/userInfo/query',
    data
  })
}
// 查询单个用户
export function queryIdUserInfo(data) {
  return $post({
    url: '/userInfo/queryById',
    data
  })
}
// 更新用户
export function updateUserInfo(data) {
  return $post({
    url: '/userInfo/update',
    data
  })
}
// 修改用户密码
export function changeUserPassword(data) {
  return $post({
    url: '/userInfo/changeUserPassword',
    data
  })
}
// 删除用户
export function deleteUserInfo(data) {
  return $post({
    url: '/userInfo/delete',
    data
  })
}
// 新增角色
export function addRoleInfo(data) {
  return $post({
    url: '/roleInfo/add',
    data
  })
}
// 查询角色
export function queryRoleInfo(data) {
  return $post({
    url: '/roleInfo/query',
    data
  })
}
// 查询角色单条信息
export function queryIdRoleInfo(data) {
  return $post({
    url: '/roleInfo/queryById',
    data
  })
}
// 编辑角色
export function updateRoleInfo(data) {
  return $post({
    url: '/roleInfo/update',
    data
  })
}
// 删除角色
export function deleteRoleInfo(data) {
  return $post({
    url: '/roleInfo/delete',
    data
  })
}
// 承租企业 新增
// 承租企业
export function baseRenterCompany(portType, data) {
  return $post({
    url: `/baseRenterCompany/${portType}`,
    data
  })
}
// 园区管理 新增 修改 删除  查看
export function baseParkInfo(portType, data) {
  return $post({
    url: `/baseParkInfo/${portType}`,
    data
  })
}
// 房屋管理 新增 修改 删除  查看
export function baseRoomInfo(portType, data) {
  return $post({
    url: `/baseRoomInfo/${portType}`,
    data
  })
}
export function baseRoomInfoExport (portType, data = {}) {
  return $download({
    url: `/baseRoomInfo/${portType}`,
    responseType: 'blob',
    data,
  })
}
// 公示管理 新增 修改 删除  查看
export function noticeInfo(portType, data) {
  return $post({
    url: `/baseNoticeInfo/${portType}`,
    data
  })
}
// 制度管理 新增 修改 删除  查看
export function baseSystemInfo(portType, data) {
  return $post({
    url: `/baseSystemInfo/${portType}`,
    data
  })
}
// 通知管理 新增 修改 删除  查看
export function baseNoticationInfo(portType, data) {
  return $post({
    url: `/baseNoticationInfo/${portType}`,
    data
  })
}

// 留言查看
export function remarkList(data) {
  return $post({
    url: `compIntentionFeedbackInfo/pageListIntentionFeedback`,
    data
  })
}
